<template>
  <div class="page compaire-page">
    <div class="scroll-holder"></div>
    <div class="compaire-bar as-flex main-between cross-center">
      <div class="main-container" v-if="mainMovieId">
        <mainMovieBox :mainMovieId="mainMovieId"></mainMovieBox>
      </div>
      <div class="compaire-cantainer">
        <compaireMoviesBox :movieListBriefInfo="movieListBriefInfo"></compaireMoviesBox>
      </div>
    </div>
    <div class="filter-box as-flex main-start cross-center f-2">
      <div class="filter-part as-flex main-start cross-center">
        <div
          :class="['ordered-item', 'time-ordered', before_after === 'before'?'is-selected':'']"
          @click="changeBeforeAfter('before')"
        >映前热度</div>
        <div
          :class="['ordered-item', 'box-ordered', before_after === 'after'?'is-selected':'']"
          @click="changeBeforeAfter('after')"
        >映后口碑</div>
        <el-select
          class="crowd-filter"
          :value="crowd.name"
          placeholder="请选择人群"
          @change="changeCurrentCrowd"
        >
          <el-option v-for="item in crowdConfig" :key="item.id" :label="item.name" :value="item"></el-option>
        </el-select>
        <el-dropdown trigger="click" :class="['ordered-item','cycle-filter','f-2','as-nowrap']">
          <span class="el-dropdown-link">
            {{cycle.name}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item,index) in before_after_cycle">
              <el-dropdown-item :key="'cycle_'+index">
                <div @click="changeCurrentCycle(item)" class="as-nowrap">{{item.name}}</div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-if="userInfo.can_download" class="download-part">
        <div class="download-total-btn f-2" @click="downloadTotalData">下载全局数据</div>
      </div>
    </div>
    <div
      class="chart-box as-flex flex-vertical main-start cross-center"
      v-if="!has_before_after_flag[before_after]"
    >
      <template v-for="item in currentIndexArray">
        <div :key="item.id" class="graph as-full-width">
          <graphContainer
            :key="item.id"
            :mainMovie="mainMovieBriefInfo"
            :beforeAfter="before_after"
            :movieList="movieListBriefInfo.filter((item)=>{return movieActive[item.id]===true})"
            :indexId="item.id"
            :crowd="crowd"
            :cycle="cycle"
            @showTagIntroduction="showTagIntroduction"
          ></graphContainer>
        </div>
      </template>
    </div>
    <div
      v-else
      class="has-no-data as-full-height as-full-width as-flex flex-vertical main-center cross-center"
    >
      <img class="has-no-data-img" src="../assets/images/has-no-data-3x.png" alt />
      <div class="has-no-data-tip f-2">暂无{{before_after==='before'?'映前':'映后'}}监测数据</div>
    </div>
  </div>
</template>

<script>
import surveyApi from "../api/surveyApi.js";
import movieApi from "../api/movieApi.js";
import mainMovieBox from "../components/movie_compaire_detail/mainMovieBox.vue";
import compaireMoviesBox from "../components/movie_compaire_detail/compaireMoviesBox.vue";
import graphContainer from "../components/movie_compaire_detail/graphContainer.vue";
// import graphContainer from "../components/movies/graphContainer.vue";
import { mapGetters } from "vuex";
import { clone } from "lodash";
import Vue from "vue";
import storageProcess from "../utils/storage/historyCompaireMovies";

const beforeTags = [
  { id: "awareness", label: "认知度" },
  { id: "interest", label: "兴趣读" },
  { id: "primary", label: "首选度" },
  { id: "secondary", label: "次选" },
  { id: "primary_div", label: "首选分流" },
  { id: "indicator", label: "类型感知" }
];
const afterTags = [
  { id: "rating", label: "喜爱度" },
  { id: "recommendation", label: "推荐度" },
  { id: "expectation", label: "预期达成" }
];
const tagsMapping = {
  awareness: "认知度",
  interest: "兴趣度",
  primary: "首选度",
  secondary: "次选",
  rating: "喜爱度",
  recommendation: "推荐度",
  expectation: "预期达成",
  primary_div: "首选分流",
  indicator: "类型感知"
};

export default {
  name: "movie_compaire_detail",
  props: {},
  components: {
    mainMovieBox: mainMovieBox,
    compaireMoviesBox: compaireMoviesBox,
    graphContainer: graphContainer
  },
  data() {
    return {
      isMobile: this.$store.getters["globalStatus/deviceIsMobile"],
      surveyApi: new surveyApi(),
      movieApi: new movieApi(),
      tagsMapping: tagsMapping,
      //config about page scroll
      before_after_offset: 0,
      //crowd & cycle config
      crowdConfig: [],
      cycleConfig: [],
      //the way that enter this page : 1.cycle-compaire: no main movie; 2.click single movie:has main movie
      compaire_type: undefined,
      average: {},
      before_after: "before",
      has_before_after_flag: {
        before: true,
        after: true
      },
      crowd: { id: "", name: "" },
      subCrowd: { id: "", name: "" },
      cycle: { id: "", name: "全周期" },
      showCycleOptions: false,

      mainMovieInfo: [],
      mainMovieBriefInfo: [],
      movieListInfo: [],
      movieListBriefInfo: [],

      //指标介绍显示标识
      currentPopIndex: undefined
    };
  },
  computed: {
    ...mapGetters({
      mainMovieId: "movie/getMainMovieId",
      cycleMoviesList: "movie/getCycleMoviesList",
      movieIdList: "movie/getTotalMovieIdList",
      movieActive: "movie/getMovieActive",
      userInfo: "user/getUserInfo"
    }),
    allListMovies: function() {
      if (this.mainMovieId) {
        return [this.mainMovieId].concat(this.movieIdList);
      } else {
        return this.movieIdList;
      }
    },
    currentIndexArray: function() {
      return this.before_after === "before" ? beforeTags : afterTags;
    },
    before_after_cycle: function() {
      if (this.before_after === "before") {
        return (this.cycleConfig || []).slice(0, 6);
      } else {
        let tempCycle = (this.cycleConfig || []).slice(5);
        return tempCycle;
      }
    },
    statusInfo: function() {
      let mainMovieId = this.mainMovieId;
      let cycleMoviesList = this.cycleMoviesList;
      let movieIdList = this.movieIdList;
      let movieActive = this.movieActive;
      let before_after = this.before_after;
      let crowd = this.crowd;
      let cycle = this.cycle;
      return {
        mainMovieId,
        cycleMoviesList,
        movieIdList,
        movieActive,
        before_after,
        crowd,
        cycle
      };
    }
  },
  methods: {
    async downloadTotalData() {
      let mainMovieId = undefined;
      if (this.mainMovieInfo[0] && this.mainMovieInfo[0].info) {
        mainMovieId = this.mainMovieInfo[0].info.id || undefined;
      }
      let movieListIds = this.movieListInfo
        .map(item => {
          return item.id;
        })
        .filter(item => {
          return this.movieActive[item];
        });
      let res = await this.movieApi.exportTotalData({
        ids: movieListIds,
        movie_id: mainMovieId,
        crowd: this.crowd.id,
        indicator: this.before_after
      });
      if (res.code !== 200 || res.status !== true) {
        return;
      }
      window.open(res.data.url, "_blank");
    },
    async initCrowdTags() {
      let res = await this.surveyApi.getCrowdTags();
      if (res.status !== true) {
        return;
      }
      this.crowdConfig = Object.entries(res.data).map(item => {
        return {
          id: item[0],
          name: item[1]
        };
      });
    },
    async initCycleTags() {
      let res = await this.surveyApi.getoffsetTags();
      if (res.status !== true || res.code !== 200) {
        return;
      }
      this.cycleConfig = Object.entries(res.data).map(item => {
        return {
          id: item[1],
          name: item[0]
        };
      });
      this.cycleConfig.unshift({ id: "", name: "全周期" });
    },
    gotoAddCompaireMoviePage() {
      this.$router.push({ path: "addCompaireMovies" });
    },
    changeBeforeAfter(flag) {
      this.before_after = flag;
    },
    changeCurrentCrowd(crowdObejct) {
      // this.crowd = crowdObejct;
      this.crowd = Object.assign({}, crowdObejct);
    },
    showChangeCycleOptions() {
      this.showCycleOptions = !this.showCycleOptions;
    },
    changeCurrentCycle(cycleObject) {
      this.showCycleOptions = false;
      this.cycle = cycleObject;
    },

    async getMovieListInfo(ids = []) {
      let res = await this.movieApi.getMovieListBasicInfo({ ids: ids });
      if (res.status !== true || res.code !== 200) {
        throw new Error("请求电影基本信息错误");
        return;
      }
      //如果存在过期/撤档影片，不查询该影片，并将其历史记录清除
      let tobeRemovedArr = [];
      res.data.forEach((item, index) => {
        if (item.info.launch === null && item.id > 0 && item.id < 100000000) {
          //为撤档影片
          tobeRemovedArr.push(item.id);
        }
      });
      res.data = res.data.filter(item => {
        return !tobeRemovedArr.includes(item.id);
      });
      //删除历史记录中已撤档影片
      storageProcess.deletePartialHistory(tobeRemovedArr);
      //--------------------------------------------
      //主影片
      let mainInfo = res.data.filter(item => {
        return item.id === this.mainMovieId;
      });
      this.mainMovieInfo = mainInfo;
      this.mainMovieBriefInfo = mainInfo.map(item => {
        return {
          id: item.info.id,
          title: item.info.title || "--",
          launch: item.info.launch || "--",
          poster_url: item.info.poster_url || ""
        };
      });
      //影片列表
      let movieList = res.data.filter(item => {
        return item.info.id !== this.mainMovieId;
      });
      this.movieListInfo = movieList;
      this.movieListBriefInfo = movieList.map(item => {
        return {
          id: item.info.id,
          title: item.info.title || "--",
          launch: item.info.launch || "--",
          poster_url: item.info.poster_url || ""
        };
      });
    },
    async hasBeforeAfterDataFlag(movieIdArr = []) {
      let res = await this.movieApi.has_result({ ids: movieIdArr });
      if (res.status !== true || res.code !== 200) {
        throw new Error("请求电影映前映后信息错误");
        return;
      }
      // return res.data;
      this.has_before_after_flag = res.data;
    },
    showTagIntroduction(tag_id) {
      // this.currentPopIndex = tag_id;
      // this.popupVisible = true;
    },
    async addHistoryCompairedMovieList() {
      if (this.mainMovieId || this.movieIdList.length > 1) {
        //从localstorage中去除历史对比影片
        let history_arr = storageProcess.getHistoryArray();
        //由于点击时就记录在localstorage中了，需要在此排除目前正在对比的影片
        history_arr = history_arr.filter(item => {
          return item !== this.mainMovieId && !this.movieIdList.includes(item);
        });
        await this.$store.dispatch("movie/addHistoryMovieList", {
          list: history_arr,
          type: "local"
        });
        return Promise.resolve();
      }
    },
    async tabPageSetting() {
      let statusCode = this.$route.query.statusCode;
      if (statusCode) {
        //有statusCode,均是点击页签进入，根据statusCode从store中拿取数据，并且不再需要pushTab
        this.$store.commit("tabpage/setCurrentTabByStatusCode", {
          statusCode: statusCode
        });
        let tabpageInfo = this.$store.getters[
          "tabpage/getCurrentTabStatusInfo"
        ];
        this.initPageTabInfo(tabpageInfo);
        return;
      }
      //改变tab名
      let curTitle = undefined;
      if (this.$route.query.compaire_type === "single" && this.mainMovieId) {
        //单个对比,tab名为主影片名
        let res = await this.movieApi.getMovieListBasicInfo({
          ids: [this.mainMovieId]
        });
        curTitle = res.data[0].info.title;
      }
      this.$store.commit("tabpage/pushTab", {
        title: curTitle || "影片对比",
        pathname: this.$route.name || "notfound",
        pathquery: Object.assign({}, this.$route.query),
        // pathparams: Object.assign({}, this.$route.params),
        type: "movies",
        statusInfo: {
          mainMovie: this.mainMovieId,
          movieList: this.cycleMoviesList,
          filters: {}
        }
      });
    },
    initPageTabInfo(data) {
      //将filter中的数据映射回来
      let {
        mainMovieId,
        cycleMoviesList,
        movieIdList,
        movieActive,
        ...filters
      } = data.filters;
      //如果本地储存记录中，有已删除
      if (mainMovieId) {
        this.$store.commit("movie/setMainMovie", {
          id: mainMovieId
        });
      }
      if (cycleMoviesList && cycleMoviesList.length > 0) {
        this.$store.commit("movie/setCycleMoviesList", {
          list: cycleMoviesList
        });
      }
      if (movieIdList && movieIdList.length > 0) {
        this.$store.commit("movie/addMovieList", {
          list: movieIdList
        });
      }
      this.$store.commit("movie/updateTotalMovieState");
      if (movieActive) {
        this.$store.commit("movie/updateMovieActive", movieActive);
      }
      Object.entries(filters).forEach(item => {
        if (this[item[0]] !== undefined) {
          this[item[0]] = item[1];
        }
      });
    }
  },
  watch: {
    statusInfo: {
      handler: function(to, from) {
        if (!to.mainMovieId && to.cycleMoviesList.length === 0) {
          //页面初始化，不更新tab
          return;
        }
        this.$store.commit("tabpage/updateCurrentTab", {
          statusInfo: {
            filters: clone(to)
          }
        });
      },
      deep: true
    },
    allListMovies: async function(to, from) {
      //call api to get movieList info
      if (this.compaire_type === "single" && to.length === 1 && to[0] === 0) {
        return;
      }
      await this.getMovieListInfo(to);
      await this.hasBeforeAfterDataFlag(
        [
          ...to.filter(item => {
            return item && item !== 0;
          })
        ].concat(this.mainMovieId || [])
      );
    },
    before_after: async function(to, from) {
      if (to === "before") {
        if (this.cycle.name === "" || [1].includes(this.cycle.id)) {
          this.cycle = { id: "", name: "全周期" };
        } else {
          // this.cycle = { id: "", name: "全周期" };
        }
      } else if (to === "after") {
        if (
          this.cycle.name === "" ||
          [-4, -3, -2, -1, ""].includes(this.cycle.id)
        ) {
          this.cycle = { id: 1, name: "映后1周" };
        } else {
          // this.cycle = { id: 1, name: "映后1周" };
        }
      }
      await this.hasBeforeAfterDataFlag(
        [
          ...this.movieIdList.filter(item => {
            return item && item !== 0;
          })
        ].concat(this.mainMovieId || [])
      );
    },
    $route: async function(to, from) {
      await this.tabPageSetting();
    }
  },
  async created() {
    this.tabPageSetting();
    this.compaire_type =
      this.$route.query.compaire_type === "single" ? "single" : "multi";
    //初始化crowd tag 并选中第一个
    await this.initCrowdTags();
    if (!this.crowd.id) {
      this.changeCurrentCrowd({ id: "overall", name: "总体" });
    }
    //获取cycle tag
    await this.initCycleTags();

    await this.hasBeforeAfterDataFlag(
      [
        ...this.movieIdList.filter(item => {
          return item && item !== 0;
        })
      ].concat(this.mainMovieId || [])
    );

    await this.addHistoryCompairedMovieList();
    await this.getMovieListInfo(this.allListMovies);
  },
  mounted() {},
  beforeDestroy() {
    // sessionStorage.setItem(
    //   "movie_compaire_detail",
    //   JSON.stringify(clone(this.sessionStorageData))
    // );
  }
};
</script>

<style lang="scss" scoped>
.compaire-page {
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  // height: 100%;
  position: relative;
  overflow-y: scroll;
  padding: 0 20px;
  min-width: 800px;
}
.scroll-holder {
  width: 100%;
  height: 20px;
  background-color: #f9f9f9;
}
.compaire-bar {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  z-index: 2000;
  background-color: #f9f9f9;
  // overflow: scroll;
  .main-container {
    width: 42%;
    height: 100%;
    margin-right: 20px;
    min-width: 600px;
  }
  .compaire-cantainer {
    width: 56%;
    height: 100%;
    background-color: #fff;
    flex-grow: 1;
  }
}
.filter-box {
  height: 50px;
  width: 100%;
  padding: 0 10px;
  background-color: #fff;
  // position: relative;
  border-bottom: 1px solid #efefef;
  position: sticky;
  position: -webkit-sticky;
  top: 200px;
  box-shadow: 0px 2px 2px -2px #efefef;
  z-index: 2000;
  .filter-part {
    position: relative;
    flex-grow: 1;
  }
  .download-part {
    flex-grow: 0;
  }
  .ordered-item {
    cursor: pointer;
    margin: 0 10px;
    border-bottom: 2px solid rgba(0, 0, 0, 0);
    &:hover {
      color: #61b6e6;
    }
    &.is-selected {
      color: #008cd6;
      border-bottom: 2px solid #008cd6;
    }
  }
  .cycle-filter {
    position: absolute;
    right: 10px;
    top: 50%;
    max-width: 100px;
    transform: translateY(-50%);
  }
  .crowd-filter {
    position: absolute;
    right: 110px;
    top: 50%;
    max-width: 200px;
    transform: translateY(-50%);
  }
  .download-total-btn {
    height: 30px;
    color: #fff;
    cursor: pointer;
    padding: 5px 20px;
    background-color: #3085e5;
    box-shadow: 0 0 2px 2px #3085e5;
    border-radius: 15px;
  }
}
.chart-box {
  // height: calc(100% - 270px);
  width: 100%;
  padding: 0 10px;
  // overflow-y: scroll;
  background-color: #fff;
  .graph {
    margin: 10px;
    box-shadow: 0 0 2px 1px #efefef;
    flex-shrink: 0;
  }
}
.has-no-data {
  height: 400px;
  background-color: #f8f8f8;
  color: #999999;
  .has-no-data-img {
    width: 80px;
    margin: 20px 0;
  }
}

/deep/ .el-input__inner {
  background-color: #fff;
  border: none;
}
</style>
